// extracted by mini-css-extract-plugin
export default {"journey-button":"JourneyButton_journey-button__yWDWA","journey-button__button":"JourneyButton_journey-button__button__ljYe1"};